// (Copyright) Confluent, Inc.

import * as React from 'react';

export function withDisableStyleOverrides<Props>(
  Component: React.ComponentType<Props> | string
): React.ComponentType<Props> | string {
  return function WrapperComponent({
    className,
    style,
    ...props
  }: Props & {
    className?: string;
    style?: {
      [key: string]: unknown;
    };
  }) {
    if (__DEV__) {
      if (className || style) {
        const passedProps = [className ? 'className' : null, style ? 'style' : null].filter(
          (id) => id
        );

        // eslint-disable-next-line no-console
        console.warn(
          `Prop(s) ${passedProps.join(', ')} are ignored for component ${getDisplayName(
            Component
          )} due to withDisableStyleOverrides HOC.`
        );
      }
    }

    // @ts-expect-error - TS2322 - Type 'Omit<Props & { className?: string; style?: { [key: string]: unknown; }; }, "style" | "className">' is not assignable to type 'IntrinsicAttributes & Props & { children?: ReactNode; }'.
    return <Component {...props} />;
  };
}

function getDisplayName(WrappedComponent: any): string {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
